import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    WDSButton,
    Typography,
    TripModes,
    DepartSchedule,
    ScheduleEndpoint,
    ScheduleCarrierInfo,
} from 'wanderu-components';
import {
    localize,
    selectLocale,
} from 'wanderu-i18n';
import {
    CaretRight,
    Circle,
    Line,
} from 'wanderu-icons';
import { convertToMillisecondsFromDecimalTime } from 'wanderu-utils';

import Duration from 'wanderu-component-search-result/src/components/SearchResult/Duration/Duration.jsx';

import styles from './ScheduleItem.scss';

function TimelineArrow(props) {
    const {
        duration,
        transfers,
    } = props;

    return (
        <div
            className={styles.arrowContainer}
            aria-hidden
        >
            {duration}
            <Line className={styles.line} />
            <CaretRight className={styles.caretRight} />
            {transfers > 0 && <Circle className={styles.transferDot} />}
        </div>
    );
}

const ScheduleItem = ({
    t,
    i18nMoney,
    locale,
    transfers,
    vehicletypes,
    carriercode,
    carriername,
    className,
    departdows,
    departlocaltime,
    departcityname,
    departstationname,
    arrivelocaltime,
    arrivecityname,
    arrivestationname,
    duration,
    minpriceusd,
}) => {
    const millisecondDuration = convertToMillisecondsFromDecimalTime(duration);

    return (
        <div className={`${styles.scheduleItem} ${className}`}>
            <div className={styles.carrierInfo}>
                <TripModes
                    className={styles.tripModes}
                    modes={vehicletypes}
                />
                <ScheduleCarrierInfo
                    carrierCode={carriercode}
                    carrierName={carriername}
                    tripModes={vehicletypes}
                />
            </div>
            <DepartSchedule
                className={styles.departSchedule}
                days={departdows}
                locale={locale}
            />
            <ScheduleEndpoint
                cityName={departcityname}
                className={styles.departEndpoint}
                dateTime={departlocaltime}
                name={departstationname}
                nearby={false}
                type="depart"
            />
            <TimelineArrow
                duration={(
                    <Duration
                        className={`${styles.duration} ${styles.durationEndpoint}`}
                        duration={millisecondDuration}
                    />
                )}
                transfers={transfers}
            />
            <ScheduleEndpoint
                cityName={arrivecityname}
                className={styles.arriveEndpoint}
                dateTime={arrivelocaltime}
                name={arrivestationname}
                nearby={false}
                type="arrive"
            />
            <Typography
                className={styles.scheduleButton}
                variant="button"
            >
                {t('from-price', {
                    price: i18nMoney(minpriceusd).format(),
                })}

            </Typography>
            {/* <WDSButton
                className={styles.scheduleButton}
                variant="text"
            >
                {t('from-price', {
                    price: i18nMoney.format(i18nMoney(defaultPrice).getTotalPrice()),
                })}
            </WDSButton> */}
        </div>
    );
};

ScheduleItem.propTypes = {
    vehicletypes: PropTypes.array.isRequired,
    carriercode: PropTypes.string.isRequired,
    carriername: PropTypes.string.isRequired,
    className: PropTypes.string,
    departdows: PropTypes.array.isRequired,
    departlocaltime: PropTypes.string.isRequired,
    departcityname: PropTypes.string.isRequired,
    departstationname: PropTypes.string.isRequired,
    arrivelocaltime: PropTypes.string.isRequired,
    arrivecityname: PropTypes.string.isRequired,
    arrivestationname: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
    minpriceusd: PropTypes.number.isRequired,
    transfers: PropTypes.number.isRequired,
};

ScheduleItem.defaultProps = {
    className: '',
    transfers: 0,
};

function mapStateToProps(state) {
    return {
        locale: selectLocale(state),
    };
}

export default connect(mapStateToProps)(localize(ScheduleItem, ['t', 'i18nMoney'], 'baseApp'));
